module.exports = __webpack_public_path__ + "img/social-studies-8-en.bfcc2fbe.png";